import { render, staticRenderFns } from "./PrivacyTabContainer.vue?vue&type=template&id=20827d81&"
import script from "./PrivacyTabContainer.vue?vue&type=script&lang=js&"
export * from "./PrivacyTabContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports